import { createSlice } from "@reduxjs/toolkit";

import { AuthSlice } from "./types";

export const initialState: AuthSlice = {
  userProfile: undefined,
  userRole: undefined,
  userAvatar: undefined,
};

export const authSlice = createSlice({
  name: "authSlice",
  initialState,
  reducers: {
    setUserProfile: (state, action) => ({
      ...state,
      userProfile: action.payload,
    }),
    setUserRole: (state, action) => ({
      ...state,
      userRole: action.payload,
    }),
    setUserAvatar: (state, action) => ({
      ...state,
      userAvatar: action.payload,
    }),
    clearAuthData: () => initialState,
  },
});

export const { setUserProfile, setUserRole, setUserAvatar, clearAuthData } =
  authSlice.actions;
export const authReducer = authSlice.reducer;
